import React from 'react';
import {
    withStyles,
    Grid,
    ButtonBase,
    Typography,
    withRouter
} from '../../material-ui';
import MBack from '../view/MBack';
import MSnackbar from '../view/MSnackbar';
import AppUtils from '../../control/apputlis'; 
import ChatSearchItem from './ChatSearchItem';
import FIMUtils from '../../im/FIMUtils';

const ICON_SEARCH = require('../../images/icons/icon_search.png');

class ChatSearchFriend extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchVal: '',
            data: [],
        };
    }

    componentDidMount() {
        AppUtils.YMPush('MAIN', 'ChatSearchFriend');
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    _onSearchClick = () => {
        const { searchVal } = this.state;
        if (searchVal.length == 0) {
            return;
        }
        let userIDList = [];
        userIDList.push(searchVal);
        userIDList.push(searchVal);
        let result = FIMUtils.getUserProfile(userIDList);
        this.setState({ data: result });
    }

    onChatClick = (item, i) => {
        let userId = item.userID;
        let nick = item.nick;
        this.props.history.push({ pathname: '/privateletter/' + userId + '/userProfile', data: nick });
    }

    render() {
        const { classes } = this.props;
        const { searchVal, data } = this.state;
        return (
            <MBack title='搜索朋友'>
                <Grid container direction='row' style={{ height: 32 }}></Grid>
                <Grid container direction='column' alignItems='center' className={classes.container}>
                    <Grid container direction='row' alignItems='center' className={classes.searchView}>
                        <img src={ICON_SEARCH} style={{ width: 18, height: 18, marginLeft: 8 }}></img>
                        <form action="">
                            <input
                                type='text' 
                                onChange={event => this.setState({ searchVal: event.target.value })}
                                value={searchVal}
                                className={classes.searchInput}
                                placeholder='搜索用户ID' />
                        </form>
                    </Grid>
                    <Grid container direction='row' alignItems='center' style={{ marginTop: 24 }}>
                        <ButtonBase onClick={() => this._onSearchClick()}>
                            <Grid container direction='row' alignItems='center' justifycontent='center' className={classes.searchButton}>
                                <Typography style={{ fontSize: 15, color: '#FFF', fontWeight: 'bold' }}>搜索</Typography>
                            </Grid>
                        </ButtonBase>
                    </Grid>
                </Grid>
                <Grid container direction='column' alignItems='center' style={{ marginTop: 32 }}>
                    {
                        data.map((item, i) => (
                            <ChatSearchItem key={i} data={item} onClick={() => this.onChatClick(item)} />
                        ))
                    }
                </Grid>
                <MSnackbar ref={(ref) => { this.toast = ref }} />
            </MBack >
        );
    }
}
export default withRouter(withStyles((theme) => ({
    container: {
        width: '100vw',
        padding: theme.spacing(0, 1.5, 0, 1.5),
    },
    searchView: {
        backgroundColor: '#F2F2F2',
        width: 'calc(100vw - 24px)',
        height: 32,
        borderRadius: 8,
    },
    searchInput: {
        flex: 1,
        width: '100%',
        height: '100%',
        margin: theme.spacing(0, 0, 0, 1),
        backgroundColor: 'transparent',
        justifyContent: 'center',
        border: 'none',
        outline: 'none',
        color: '#3A445F',
        fontSize: theme.typography.pxToRem(11),
    },
    searchButton: {
        height: 32,
        backgroundColor: '#2E2E2E',
        borderRadius: 16,
        width: 'calc(100vw - 24px)',
    }
}))(ChatSearchFriend));